import React from 'react';
import { Flex } from 'antd';

import { ChatBackButton } from '../components/ChatBackButton';
import { MembersStatistics } from '../features/AnalyticMembers/components/MembersStatistics';
import { AnalyticsFilters } from '../features/AnalyticsFilters';

export const PageHeader = () => {
    return (
        <>
            <Flex justify={'space-between'} align={'center'}>
                <ChatBackButton />
                <AnalyticsFilters />
            </Flex>
            <MembersStatistics />
        </>
    );
};
